<template>
  <v-row row wrap>

    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="8">
          <!-- FILTERS HERE -->
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <search-input @search="performSearch" v-model="search"/>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">

      <v-data-table
          class="mt-3"
          :headers="headers"
          :items="items"
          :search="search"
          :single-expand="false"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="pageNumber"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="orderBy"
          :sort-desc.sync="orderDesc"
          :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
          @update:page="fetch"
          @update:sort-by="fetch"
          @update:sort-desc="fetch"
          @update:items-per-page="fetch"
      >


        <template v-slot:item.backgroundColor="{item}">
          <v-chip v-if="item.backgroundColor" :color="item.backgroundColor" small>
            {{ item.backgroundColor }}
          </v-chip>
        </template>

        <template v-slot:item.borderColor="{item}">
          <v-chip v-if="item.borderColor" :color="item.borderColor" small>
            {{ item.borderColor }}
          </v-chip>
        </template>

        <template v-slot:item.fontColor="{item}">
          <v-chip v-if="item.fontColor" :color="item.fontColor" small>
            {{ item.fontColor }}
          </v-chip>
        </template>

        <template v-slot:item.icon="{item}">
          <v-chip v-if="item.icon" :color="item.iconColor ? item.iconColor : null "  small >
            <v-icon left>{{item.icon}}</v-icon>{{ item.icon }}
          </v-chip>
        </template>

        <template v-slot:item.homeGallery="{item}">
          <v-icon v-if="item.homeGallery" color="green">done</v-icon>
          <v-icon v-else color="red">clear</v-icon>
        </template>

        <template v-slot:item.active="{item}">
          <v-icon v-if="item.active" color="green">check</v-icon>
          <v-icon v-else color="red">clear</v-icon>
        </template>

        <template v-slot:item.drink="{item}">
          <v-icon v-if="item.drink" color="green">local_bar</v-icon>
          <v-icon v-else color="red">clear</v-icon>
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">
          <show-button @click="$emit('show', item)"/>
          <edit-button @click="$emit('update', item)"/>
          <delete-button v-if="false" @click="$emit('delete', item)"/>
        </template>

      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import ProductCategoryProvider from "../../../../providers/ProductCategoryProvider";

import {DeleteButton, EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"


export default {
  name: "ProductCategoryList",
  components: {DeleteButton, EditButton, ShowButton, SearchInput},

  data() {
    return {
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: [
        /*{
            field: '',
            operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
            value: ''
        }*/
      ]
    }
  },
  computed: {
    headers() {
      return [
        //Entity Headers
        {text: this.$t('delivery.productCategory.labels.active'), value: 'active'},
        {text: this.$t('delivery.productCategory.labels.name'), value: 'name'},
        // {text: this.$t('delivery.productCategory.labels.backgroundColor'), value: 'backgroundColor'},
        // {text: this.$t('delivery.productCategory.labels.borderColor'), value: 'borderColor'},
        // {text: this.$t('delivery.productCategory.labels.fontColor'), value: 'fontColor'},
        {text: this.$t('delivery.productCategory.labels.printName'), value: 'printName'},
        // {text: this.$t('delivery.productCategory.labels.surcharge'), value: 'surcharge'},
        // {text: this.$t('delivery.product.labels.homeGallery'), value: 'homeGallery'},
        {text: this.$t('delivery.productCategory.labels.icon'), value: 'icon'},
        {text: this.$t('delivery.productCategory.labels.drink'), value: 'drink'},
        {text: this.$t('delivery.productCategory.labels.minimumDeliveryQuantity'), value: 'minimumDeliveryQuantity'},
        {text: this.$t('delivery.productCategory.labels.minimumTakeAwayQuantity'), value: 'minimumTakeAwayQuantity'},
        //Actions
        {text: this.$t('common.actions'), value: 'action', sortable: false},
      ]
    },
    getOrderBy() {
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc() {
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    performSearch() {
      this.pageNumber = 1
      this.fetch()
    },
    fetch() {
      this.loading = true
      ProductCategoryProvider.paginateProductCategory(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.paginateProductCategory.items
        this.totalItems = r.data.paginateProductCategory.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    }
  }

}
</script>


